var _circle, _circle2, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultsSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 124.999,
    r: 108.333,
    fill: "#BFCBFE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.417,
    cy: 125.417,
    r: 95.4167,
    fill: "#8199F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_389_7240)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 124.999,
    r: 83.3333,
    fill: "#3855CA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.545 124.899C101.465 121.497 95.6544 116.463 91.3131 109.865C88.5079 105.647 86.5042 100.953 85.3687 95.987C84.4337 92.1775 84.1665 88.3 84.1665 84.3544C84.1665 83.8782 84.5672 83.402 85.1016 83.402H97.7917C98.326 83.402 98.7268 83.8102 98.7268 84.3544V87.4156C98.7268 87.9598 98.326 88.368 97.7917 88.368H89.9773C89.4429 88.368 89.0422 88.8442 89.0422 89.3884C89.1758 90.4088 89.2426 91.3612 89.3761 92.3136C90.9123 101.293 95.0533 108.776 101.732 114.763C102.133 115.103 102.4 115.579 102.734 115.987C104.137 118.096 105.473 120.205 106.875 122.314C107.209 122.858 107.677 123.266 108.077 123.742C108.478 124.218 108.879 124.627 109.28 125.035C108.946 125.035 108.745 124.967 108.545 124.899ZM164.248 83.402H151.558C151.024 83.402 150.623 83.8102 150.623 84.3544V87.4156C150.623 87.9598 151.024 88.368 151.558 88.368H159.306C159.84 88.368 160.241 88.8442 160.241 89.3884C160.107 90.4088 160.04 91.3612 159.907 92.3136C158.37 101.293 154.229 108.776 147.55 114.763C147.15 115.103 146.883 115.579 146.549 115.987C145.146 118.096 143.81 120.205 142.408 122.314C142.074 122.858 141.606 123.266 141.205 123.742C140.805 124.218 140.404 124.627 140.003 125.035C140.27 125.035 140.471 124.967 140.671 124.899C147.751 121.497 153.562 116.463 157.903 109.865C160.708 105.647 162.712 100.953 163.847 95.987C164.782 92.1775 165.049 88.3 165.049 84.3544C165.183 83.8102 164.716 83.402 164.248 83.402ZM147.684 162.654V165.715C147.684 166.259 147.283 166.667 146.749 166.667H102.467C101.933 166.667 101.532 166.259 101.532 165.715V162.722C101.532 162.178 101.933 161.769 102.467 161.769C104.604 161.769 106.341 160.001 106.341 157.824V149.592C106.341 145.511 109.547 142.246 113.554 142.246H118.964C119.499 142.246 119.899 141.837 119.899 141.293V134.15C119.899 133.47 120.567 133.062 121.102 133.266C121.97 133.606 122.771 133.946 123.573 134.218C124.307 134.49 125.042 134.49 125.777 134.218C126.578 133.946 127.38 133.606 128.181 133.334C128.782 133.13 129.45 133.538 129.45 134.218V141.225C129.45 141.769 129.851 142.178 130.385 142.178H135.862C139.87 142.178 143.076 145.443 143.076 149.524V157.756C143.076 159.933 144.812 161.701 146.949 161.701C147.283 161.701 147.684 162.109 147.684 162.654ZM131.721 151.293C131.721 150.749 131.32 150.341 130.786 150.341H118.363C117.829 150.341 117.428 150.749 117.428 151.293V154.218C117.428 154.763 117.829 155.171 118.363 155.171H130.786C131.32 155.171 131.721 154.763 131.721 154.218V151.293ZM104.805 108.912C108.077 118.64 114.556 125.443 124.107 129.252C124.374 129.388 124.775 129.388 125.042 129.32C130.452 127.28 134.994 124.082 138.667 119.524C143.743 113.266 146.148 106.055 146.148 97.9598C146.148 93.402 146.148 88.8442 146.148 84.2864C146.148 83.7421 145.747 83.334 145.213 83.334H104.07C103.536 83.334 103.135 83.7421 103.135 84.2864C103.135 88.9802 103.135 93.6741 103.135 98.368C103.135 102.041 103.669 105.579 104.805 108.912Z",
    fill: "#8199F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_389_7240",
    x: 41.6665,
    y: 41.666,
    width: 166.667,
    height: 170.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_389_7240"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsSuccess);
export default __webpack_public_path__ + "static/media/results-success.a0b103de1742d4e61363c7c6fbd2f565.svg";
export { ForwardRef as ReactComponent };